import React from 'react';
import { motion } from 'framer-motion';
import { Phone, Send, FileText } from 'lucide-react';
import { useLang } from '../context/LanguageContext';

export default function InvestorCTA() {
  const { lang } = useLang();

  const content = lang === 'ru' ? {
    title: 'Готовы обсудить запуск?',
    subtitle: 'Оставьте заявку или напишите нам — ответим и покажем модель',
    risk_free: 'Без обязательств. Просто обсуждение.',
  } : {
    title: '¿Listo para discutir el lanzamiento?',
    subtitle: 'Deje una solicitud o escríbanos — responderemos y mostraremos el modelo',
    risk_free: 'Sin compromisos. Solo una conversación.',
  };

  const cta = lang === 'ru' ? {
    call: 'Позвонить',
    telegram: 'Написать в Telegram',
    presentation: 'Получить презентацию',
  } : {
    call: 'Llamar',
    telegram: 'Escribir por Telegram',
    presentation: 'Obtener presentación',
  };

  return (
    <section id="contacts" className="relative py-20 md:py-28 px-6 overflow-hidden">
      {/* Background gradient */}
      <div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(135deg, rgba(212,175,55,0.08) 0%, rgba(107,78,255,0.08) 100%)',
        }}
      />

      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center"
        >
          {/* Title */}
          <h2 className="text-4xl md:text-6xl font-black font-heading gold-text mb-6">
            {content.title}
          </h2>
          <p className="text-[#BFC3C9] text-lg md:text-xl mb-12">
            {content.subtitle}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a
              href="tel:+34624586917"
              className="btn-call flex items-center gap-3 px-8 py-4 rounded-full text-base font-bold w-full sm:w-auto justify-center min-w-[200px]"
            >
              <Phone size={20} />
              {cta.call}
            </a>
            <a
              href="https://t.me/SerjValencia"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-telegram flex items-center gap-3 px-8 py-4 rounded-full text-base font-bold w-full sm:w-auto justify-center min-w-[200px]"
            >
              <Send size={20} />
              {cta.telegram}
            </a>
          </div>

          {/* Risk-free message */}
          <motion.p
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-[#22C55E] text-sm md:text-base font-semibold mb-6"
          >
            ✓ {content.risk_free}
          </motion.p>

          {/* Secondary CTA */}
          <motion.a
            href="mailto:kidsmafia.vlc@gmail.com?subject=Franchise Presentation Request"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="inline-flex items-center gap-2 text-[#D4AF37] hover:text-[#FFD700] transition-colors text-sm md:text-base font-semibold"
          >
            <FileText size={18} />
            {cta.presentation}
          </motion.a>
        </motion.div>

        {/* Contact info */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-12 pt-8 border-t border-white/10 text-center"
        >
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-[#9CA3AF] text-sm">
            <span>+34 624 586 917</span>
            <span className="hidden sm:inline">•</span>
            <span>kidsmafia.vlc@gmail.com</span>
            <span className="hidden sm:inline">•</span>
            <span>@SerjValencia</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
